import { useState, useEffect } from 'react';
import { useAvaliacoesProfessorPage } from './useAvaliacoesProfessorPage';
import { AvaliacoesProfessorDesktop } from './AvaliacoesProfessorDesktop';
import { AvaliacoesMobileView } from './AvaliacoesMobileView';

function useIsMobile(bp = 768) {
  const [m, setM] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < bp : false,
  );
  useEffect(() => {
    const fn = () => setM(window.innerWidth < bp);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, [bp]);
  return m;
}

export function AvaliacoesPage() {
  const isMobile = useIsMobile();
  const ctx = useAvaliacoesProfessorPage();

  if (!isMobile) {
    return (
      <div
        className="aval-desk-host"
        style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}
      >
        <AvaliacoesProfessorDesktop ctx={ctx} />
      </div>
    );
  }

  return <AvaliacoesMobileView ctx={ctx} />;
}
